module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1jeZRR/tc-custom/9781685505677.jpg?1716663163918",
      "alt": "This image is the cover for the book Vampire's Delight"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Vampire's Delight\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sequel to "), _c('i', [_vm._v("The Blood Witch")]), _c('br'), _c('br'), _vm._v("Vampires, blood witches, and murders!"), _c('br'), _c('br'), _vm._v("All Duncan Caddock wants is to make people believe he's human, and for the most part, he succeeds. He's working as a detective and is solving human crimes. But he's not a human; he's a blood witch. The life of a blood witch isn't pleasant, though, and he refuses to live like one. It all works out great until he outs himself by using his powers on a vampire."), _c('br'), _c('br'), _vm._v("Urien Sayer wants to hide in his house, but as second in command in the kingdom of supernaturals, he has to be seen. Then one night, he accidentally tries to take a bite out of the town's new detective, only to realize the detective isn't as human as he pretends to be."), _c('br'), _c('br'), _vm._v("Blood witches are valuable, and Urien wants to keep Duncan in the kingdom and preferably in his bed. Duncan isn't sure staying in Norbridge is a good idea, but when people are starting to get murdered, he gets dragged further into the world of the supernaturals than he'd ever planned on. And if he's gonna solve murders on the supernatural side of society, who better to have by his side than the top vampire?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Holly Day\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0